import * as Device from 'react-device-detect';

import { DesktopCalendar } from './desktop';
import { MobileCalendar } from './mobile';

export const Calendar = Device.isMobileOnly ? MobileCalendar : DesktopCalendar;